import React from 'react'
import StaminaAllFour from './StaminaAllFour'
import Stars from './Stars'
import StaminaTwoSubjects from './StaminaTwoSubjects'

export default function ({stars, byItem, assessmentSubtests}) {
  return (
    <div className="skill-box stamina">
      <div className="skill-information">
        <h1 className="skill-name">Stamina</h1>
        <Stars stars={stars} />
        <p className="skill-description">
          This rating shows the likelihood that your students maintained a high energy level throughout the test. The graphic shows overall
          trends that could portray test fatigue by heat mapping the percentage of students who answered each test question correctly
          over the entire test and over particular subject areas.
			  </p>
      </div>
      <div className="skill-graphs">
        <div className="reports">
          <StaminaAllFour
            byItem={byItem}
            assessmentSubtests={assessmentSubtests}
          />
          <StaminaTwoSubjects
            subjects={'ELA'}
            byItem={byItem}
            assessmentSubtests={assessmentSubtests}
          />
          <StaminaTwoSubjects
            subjects={'STEM'}
            byItem={byItem}
            assessmentSubtests={assessmentSubtests}
          />
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/Stamina.js